import { useSelector } from 'react-redux';
import { StoreAuthMemberProper } from 'store/types';

export default function useActiveMember() {
  return useSelector((state: { authMember: StoreAuthMemberProper }) => state.authMember);
}
